module.exports = "/_next/static/images/instrument_7-81f30b524dd1d5df17b7429c70461243.png";